export type AssistantAskStatus = 'ANSWERED' | 'CLARIFY' | 'NO_MATCH' | 'OUT_OF_SCOPE' | 'UNCLEAR';

export interface AssistantTopicLabels {
  en: string;
  es: string;
}

/** Safe citation fields only — never a chunk id/documentId/filesystem path (backend never sends
 * those, but the frontend must never render them even if present in some future debug payload). */
export interface AssistantCitation {
  topic: string;
  label: AssistantTopicLabels;
  documentTitle: string;
  heading: string;
}

export interface AssistantAskClarificationOption {
  topic: string;
  label: AssistantTopicLabels;
}

export interface AssistantAskResponse {
  status: AssistantAskStatus;
  answer?: string;
  message?: string;
  clarification?: { topics: AssistantAskClarificationOption[] };
  citations?: AssistantCitation[];
  reason?: string;
}

export interface HelpAssistantApiMessage {
  role: 'user' | 'assistant';
  content: string;
}

export interface AskHelpAssistantRequest {
  question: string;
  route?: string;
  history: HelpAssistantApiMessage[];
  /** UI scope hints ONLY — the backend re-validates/derives real access server-side. */
  requestedTopic?: string;
  requestedDomain?: string;
  locale?: 'en' | 'es';
}

export interface AssistantTaxonomyTopic {
  topic: string;
  domain: string;
  labels: AssistantTopicLabels;
}

export interface AssistantTaxonomyDomain {
  id: string;
  labels: AssistantTopicLabels;
  topics: string[];
}

/** Whatever the backend returns is rendered as-is — never a second hardcoded source of domains/topics. */
export interface AssistantTaxonomyResponse {
  domains: AssistantTaxonomyDomain[];
  topics: AssistantTaxonomyTopic[];
}

/** A single clarification bubble's own resend context, kept per-message so multiple clarify
 * turns in the same conversation never clash with each other. */
export interface HelpAssistantClarificationState {
  originalQuestion: string;
  options: AssistantAskClarificationOption[];
  selectedTopic?: string;
}

export interface HelpAssistantMessage {
  role: 'user' | 'assistant';
  content: string;
  citations?: AssistantCitation[];
  clarification?: HelpAssistantClarificationState;
}
